"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
const typography = {
    /* Section heading */
    a1: {
        fontFamily: merlin_theme_1.default.typography.fonts.base,
        fontWeight: 500,
        fontSize: '1.5rem',
        lineHeight: '1.875rem',
        color: merlin_theme_1.default.colours.neutral.darkest,
    },
    /* Section sub-heading */
    a2: {
        fontFamily: merlin_theme_1.default.typography.fonts.base,
        fontWeight: 500,
        fontSize: '1.125rem',
        lineHeight: '1.375rem',
        color: merlin_theme_1.default.colours.neutral.darkest,
    },
    /* Section sub-sub-heading */
    a3: {
        fontFamily: merlin_theme_1.default.typography.fonts.base,
        fontWeight: 500,
        fontSize: '1rem',
        lineHeight: '1.25rem',
        color: merlin_theme_1.default.colours.neutral.darkest,
    },
    /* Paragraph */
    b1: {
        fontFamily: merlin_theme_1.default.typography.fonts.base,
        fontWeight: 400,
        fontSize: '1rem',
        lineHeight: '1.25rem',
        color: merlin_theme_1.default.colours.neutral.darker,
    },
    /* Input label */
    c1: {
        fontFamily: merlin_theme_1.default.typography.fonts.base,
        fontWeight: 500,
        fontSize: '1.125rem',
        lineHeight: '1.375rem',
        color: merlin_theme_1.default.colours.neutral.darkest,
    },
    /* Support text label */
    c2: {
        fontFamily: merlin_theme_1.default.typography.fonts.base,
        fontWeight: 400,
        fontSize: '1rem',
        lineHeight: '1.25rem',
        color: merlin_theme_1.default.colours.neutral.dark,
    },
    /* TextField input */
    c3: {
        fontFamily: merlin_theme_1.default.typography.fonts.base,
        fontWeight: 400,
        fontSize: '1rem',
        lineHeight: '1.25rem',
        color: merlin_theme_1.default.colours.neutral.darker,
    },
    /* Featured link text */
    d1: {
        fontFamily: merlin_theme_1.default.typography.fonts.base,
        fontWeight: 500,
        fontSize: '0.8125rem',
        lineHeight: '0.9375rem',
        color: merlin_theme_1.default.colours.neutral.darker,
    },
    /* Featured foot-note */
    d2: {
        fontFamily: merlin_theme_1.default.typography.fonts.base,
        fontWeight: 400,
        fontSize: '0.625rem',
        lineHeight: '0.8125rem',
        color: merlin_theme_1.default.colours.neutral.darker,
    },
    // Special cases, not to be used generally
    button: {
        fontFamily: merlin_theme_1.default.typography.fonts.base,
        fontWeight: 500,
        fontSize: '1rem',
    },
    number: {
        fontFamily: merlin_theme_1.default.typography.fonts.base,
        fontWeight: 900,
        fontSize: '3.75rem',
        color: merlin_theme_1.default.colours.neutral.darkest,
    }
};
exports.default = typography;
//# sourceMappingURL=typography.js.map